import React from 'react';
import { useLocation } from 'react-router-dom';
import './Success.css';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { jsPDF } from 'jspdf';
import { downloadVoucher } from "../utils/voucherGenerator";
import { selectIsLoggedIn } from '../auth/authSlice';
import { useSelector } from 'react-redux';

const Success = () => {

    const location = useLocation();
    const { coupon, end_date, discount, voucher_name, voucher_wish, game, description, imageUrl } = location.state || {};
    const { t, i18n } = useTranslation();
    const isLoggedIn = useSelector(selectIsLoggedIn);

    const handleDownload = () => {
        downloadVoucher({
            coupon: coupon,
            voucherName: voucher_name,
            voucherWish: voucher_wish,
            endDate: end_date,
            gameName: game,
            gameDescription: description,
            imageUrl: imageUrl,
            language: (i18n.language || 'bg').substring(0, 2)
        });
    }
    return (
        <div className="success-container">
            <div className="success-message">
                <h2>{t('success.payment_successful')}</h2>
                <p>{t('success.congratulations')}</p>
            </div>
            {coupon && end_date && (
                <div className="coupon-details">
                    <h3>{t('success.coupon_details')}</h3>
                    <p><strong>{t('success.coupon_code')}:</strong> {coupon}</p>
                    <p><strong>{t('success.use_before')}:</strong> {formatEndDate(end_date)}</p>
                </div>
            )}
            <br></br>
            {isLoggedIn ? (
                <Link to="/mygames" style={{ textDecoration: 'none' }}>
                    <button type="button" className="my-games-btn">
                        {t('success.find_your_game', { defaultValue: 'Find your game' })}
                    </button>
                </Link>
            ) : (
                <Link to="/start_game" state={{ coupon }} style={{ textDecoration: 'none' }}>
                    <button type="button" className="my-games-btn">
                        {t('start_the_game', { defaultValue: 'Start Game' })}
                    </button>
                </Link>
            )}

            {voucher_name && (
                <button className="download-voucher" onClick={handleDownload}>
                    {t('success.download_voucher')}
                </button>
            )}
        </div>
    );
};

const formatEndDate = (endDate) => {
    const parsedDate = new Date(endDate);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Intl.DateTimeFormat('en-US', options).format(parsedDate);
};

export default Success;
